/**
 * ContractEstimateSlice Edit Tracking Reducers
 * 
 * Reducers for managing loading state, dirty tracking, and validation errors.
 */

import { PayloadAction } from '@reduxjs/toolkit';
import { ContractEstimateSliceState } from '../state';
import { ReimbursementResult } from '../../../CalculatorService/types';

/**
 * Set the loading state
 */
export const setIsLoading = (
  state: ContractEstimateSliceState,
  action: PayloadAction<boolean>
) => {
  state.isLoading = action.payload;
};

/**
 * Set the calculating state
 */
export const setIsCalculating = (
  state: ContractEstimateSliceState,
  action: PayloadAction<boolean>
) => {
  state.isCalculating = action.payload;
};

/**
 * Set calculation result
 */
export const setCalculationResult = (
  state: ContractEstimateSliceState,
  action: PayloadAction<ReimbursementResult>
) => {
  if (state.currentEstimate) {
    state.currentEstimate.calculationResult = action.payload;
    state.currentEstimate.lastModified = new Date().toISOString();
  }
  state.isCalculating = false;
};

/**
 * Clear calculation result
 */
export const clearCalculationResult = (state: ContractEstimateSliceState) => {
  if (state.currentEstimate) {
    state.currentEstimate.calculationResult = undefined;
    state.currentEstimate.lastModified = new Date().toISOString();
  }
};

/**
 * Set whether there are unsaved changes
 */
export const setIsDirty = (
  state: ContractEstimateSliceState,
  action: PayloadAction<boolean>
) => {
  state.isDirty = action.payload;
};

/**
 * Set a validation error for a specific field
 */
export const setValidationError = (
  state: ContractEstimateSliceState,
  action: PayloadAction<{ field: string; message: string }>
) => {
  state.validationErrors[action.payload.field] = action.payload.message;
};

/**
 * Set all validation errors at once
 */
export const setValidationErrors = (
  state: ContractEstimateSliceState,
  action: PayloadAction<Record<string, string>>
) => {
  state.validationErrors = action.payload;
};

/**
 * Clear a validation error for a specific field
 */
export const clearValidationError = (
  state: ContractEstimateSliceState,
  action: PayloadAction<string>
) => {
  delete state.validationErrors[action.payload];
};

/**
 * Clear all validation errors
 */
export const clearAllValidationErrors = (state: ContractEstimateSliceState) => {
  state.validationErrors = {};
};
